import uniqBy from 'lodash/uniqBy';
import { updateObjectInArray, updateAccountInArray } from '@t7x000/apex-web/lib/helpers/arrayHelper';
import {
  USER_INFO_FETCHED,
  USER_CONFIG_FETCHED,
  RECEIVE_USER_PERMISSIONS,
  RECEIVE_ACCOUNT,
  SET_ACCOUNT,
  SET_GOOGLE_QRCODE,
  CLEAR_GOOGLE_QRCODE,
} from '@t7x000/apex-web/lib/redux/actions/userActions';
import { RECEIVE_VERIFICATION_LEVEL_CONFIGS } from '@t7x000/apex-web/lib/redux/actions/withdrawActions';
import { USER_CONFIG_UPDATED, UPDATE_ACCOUNT } from '@t7x000/apex-web/lib/redux/actions/kycActions';
import { RECEIVE_KYC } from '@t7x000/apex-web/lib/redux/actions/kycIdentityMindActions';
import { AUTH_NONE } from '@t7x000/apex-web/lib/redux/actions/authActions';

const getInitialState = () => ({
  userInfo: {},
  permissions: [],
  accounts: [],
  userConfig: [],
  selectedAccountId: parseInt(localStorage.getItem('selectedAccountId'), 10) || undefined,
  kyc: { urlParams: null },
  qrCode: '',
  verificationLevelConfigs: {},
});

const initialState = getInitialState();

export default function user(state = initialState, { type, payload }) {
  switch (type) {
    case AUTH_NONE:
      // Explicitly reset user state on logout to ensure no data persists
      // Must call getInitialState() to get fresh values from localStorage (which should be cleared by now)
      return getInitialState();
    case USER_INFO_FETCHED:
      return {
        ...state,
        userInfo: payload,
        selectedAccountId: payload.AccountId,
      };
    case USER_CONFIG_FETCHED:
      return {
        ...state,
        userConfig: payload,
      };
    case USER_CONFIG_UPDATED:
      return {
        ...state,
        userConfig: updateObjectInArray(state.userConfig, payload),
      };
    case RECEIVE_USER_PERMISSIONS:
      return {
        ...state,
        permissions: payload,
      };
    case RECEIVE_ACCOUNT: {
      const newAccounts = Array.isArray(payload) ? payload : [];
      const mergedAccounts = uniqBy([...state.accounts, ...newAccounts], 'AccountId');
      return {
        ...state,
        accounts: mergedAccounts,
      };
    }
    case UPDATE_ACCOUNT:
      return {
        ...state,
        accounts: updateAccountInArray(state.accounts, payload),
      };
    case RECEIVE_KYC:
      return {
        ...state,
        kyc: payload,
      };
    case SET_ACCOUNT:
      return {
        ...state,
        selectedAccountId: payload,
      };
    case SET_GOOGLE_QRCODE:
      return {
        ...state,
        qrCode: payload,
      };
    case CLEAR_GOOGLE_QRCODE:
      return {
        ...state,
        qrCode: '',
      };
    case RECEIVE_VERIFICATION_LEVEL_CONFIGS:
      return {
        ...state,
        verificationLevelConfigs: payload,
      };
    default: {
      return state;
    }
  }
}
